<template>
  <div id="main" class="bg-light">
    <div id="header">
      <!-- <div id="container"> -->
      <div id="title">
        <h3 class="title1">{{ title1 }}</h3>
        <p class="title2">
          {{ title2 }}
        </p>
      </div>
      <!-- </div> -->
    </div>
    <div id="content">
      <div id="container">
        <div id="vertikal">
          <div id="horizontal1">
            <div id="why">
              <img src="../assets/mentoring.png" />
              <h5 class="why1">{{ why1 }}</h5>
              <p class="desc1">{{ desc1 }}</p>
            </div>
            <div id="why">
              <img src="../assets/studycase.png" />
              <h5 class="why2">{{ why2 }}</h5>
              <p class="desc2">{{ desc2 }}</p>
            </div>
            <div id="why">
              <img src="../assets/portofolio2.png" />
              <h5 class="why3">{{ why3 }}</h5>
              <p class="desc3">{{ desc3 }}</p>
            </div>
            <div id="why">
              <img src="../assets/komunitas.png" />
              <h5 class="why4">{{ why4 }}</h5>
              <p class="desc4">{{ desc4 }}</p>
            </div>
            <div id="why">
              <img src="../assets/sideproject.png" />
              <h5 class="why5">{{ why5 }}</h5>
              <p class="desc5">{{ desc5 }}</p>
            </div>
            <div id="why">
              <img src="../assets/terjangkau.png" />
              <h5 class="why6">{{ why6 }}</h5>
              <p class="desc6">{{ desc6 }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "keunggulan",
  props: {
    title1: String,
    title2: String,
    why1: String,
    desc1: String,
    why2: String,
    desc2: String,
    why3: String,
    desc3: String,
    why4: String,
    desc4: String,
    why5: String,
    desc5: String,
    why6: String,
    desc6: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500&display=swap");

#main {
  /* width: 1086px; */
  padding-left: 200px;
  padding-right: 200px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
}
#header {
  flex: 20%;
}
#content {
  flex: 80%;
}
#title {
  padding: 100px 0 100px 0;
  /* width: 459px; */
  /* padding-left: 320px; */
}
#title h3 {
  font-size: 32px;
}
#vertikal {
  display: flex;
  flex-direction: column;
  padding-bottom: 91px;
  padding-left: 50px;
}
#horizontal1 {
  flex: 30%;
  display: flex;
  flex-wrap: wrap;
}
#why {
  flex: 20%;
  margin-right: 60px;
  margin-bottom: 60px;
  text-align: left;
  background-color: #ffffff;
  border-radius: 32px;
}
#why img,
#why h5,
#why p {
  text-align: justify;
  margin-top: 10px;
  margin-left: 42px;
}
#why img {
  margin-top: 31px;
  padding: 20px;
  border-radius: 50px;
  background-color: #fcab97;
}
#why h5 {
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: -5px;
}
#why p {
  padding-bottom: 48px;
}
p {
  font-size: 16px;
}

@media only screen and (max-width: 810px) {
  #main {
    padding-left: 100px;
  }
  #vertikal {
    padding-left: 0;
  }
  #why {
    margin-right: 40px;
  }
  #why img,
  #why h5,
  #why p {
    margin-left: 25px;
  }
  p {
    font-size: 14px;
  }
}

@media only screen and (max-width: 610px) {
 #main {
   padding-left: 50px;
   width: 500px;
 }
 #title {
   padding: 30px 0 0 0;
 }
 #title h3 {
   width: 220px;
   font-size: 28px;
   text-align: justify;
 }
 #title p {
   text-align: justify;
   width: 220px;
   font-size: 12px;
 }
 #why {
   margin-bottom: 0;
   margin-left: -5%;
 }
 #why h5 {
   font-size: 16px;
 }
 #why p{
   padding-bottom: 20px;
 }
 #horizontal1 {
   flex-direction: column;
 }
 #vertikal {
   padding-bottom: 0;
 }
}
</style>
